import { useState, useEffect } from "react";
import { Map, useMap } from '@vis.gl/react-google-maps'
import mapOptions from './map-options.json'
import { ClusteredMarkers } from "./cluster/clustered-marker";
import { UsersListLoading } from "../apps/user-management/users-list/components/loading/UsersListLoading";
import "./style.scss"
import { SearchMarker } from "./markers/searchMarker";

const MAP_ID = process.env.REACT_APP_GOOGLE_MAP_ID || 'bf51a910020fa25a'
const getMinZoom = (width) => {
    if (width > 2560) {
        return 5.5
    } else if ((width < 2560 && width > 1600)) {
        return 4.6
    } else if (width < 768) {
        return 3
    } else {
        return 4
    }
}

const MapContainer = ({ markers, markersLoaded, mapLoaded, center, isSearch }) => {
    const mapInstance = useMap()
    const defaultZoom = 4
    const [defaultCenter, setDefaultCenter] = useState(center)
    const [minZoom, setMinZoom] = useState(getMinZoom(window.innerWidth))

    const handleApiLoaded = () => {
        const changeScaleControlLabel = () => {
            var spn = document.querySelectorAll('.gm-style-cc')
            if (spn) {
                for (var i in spn) {
                    if ((/\d\s?(km|(m\b))/g).test(spn[i].innerText)) {
                        spn[i].click()
                    }
                }
            }
        }
        const interval = setInterval(() => {
            changeScaleControlLabel()
            if (document?.querySelector('button[title="Show imagery with street names"]')) {
                clearInterval(interval)
            }
        }, 100)
    }

    useEffect(() => {
        handleApiLoaded()
        const handleResize = () => {
            setMinZoom(getMinZoom(window.innerWidth))
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        if (isSearch && center) {
            setDefaultCenter(center)
            mapInstance.setZoom(8)
            mapInstance.panTo(center)
        }
    }, [isSearch, center])


    return (
        <>
            <div className="view-map-container">
                {
                    (!mapLoaded || !markersLoaded) &&
                    <UsersListLoading />
                }
                {mapLoaded && <Map
                    mapId={MAP_ID}
                    defaultCenter={defaultCenter}
                    defaultZoom={defaultZoom}
                    gestureHandling={'greedy'}
                    options={{
                        ...mapOptions,
                        isFractionalZoomEnabled: window.innerWidth >= 768,
                        minZoom
                    }}
                    style={{
                        width: '100%',
                        height: '100%',

                    }}
                    disableDefaultUI={true}
                >
                    {isSearch &&
                        <SearchMarker lat={center?.lat} lng={center?.lng} />
                    }
                    <ClusteredMarkers
                        data={markers?.filter(m => !m.has_controls)}
                        gateListings={markers?.filter(m => m.has_controls)}
                    />
                </Map>
                }
            </div>
        </>
    )
}

export default MapContainer